import Box from '@material-ui/core/Box';
import React from 'react';

const Page403: React.FC = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <h1>403 Unauthorized</h1>
    <span>Bummer!</span>
  </Box>
);

export default Page403;
